export default "__VITE_ASSET__8e9f0b66__"